var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDodo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 199,
    viewBox: "0 0 375 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 186.749,
    cy: 325.077,
    rx: 278.683,
    ry: 172.077,
    fill: "#199581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 133V165",
    stroke: "#FF6C44",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173 130V162",
    stroke: "#FF6C44",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 41.5,
    r: 15.5,
    fill: "#F2A581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.5 66.5C161.5 66.5 157 57.5 165.5 52.5C163.5 50.8333 159.6 46.9 156 46.5C151.5 46 152.5 55 150.5 56C128.328 67.0861 134.5 109.816 162.5 113.5C181.5 116 187 135 192 135C197 135 199 125 207.5 122C216 119 229 115.5 234.5 107C240 98.5 241.5 66.5 213.5 62C195.701 59.1394 175.059 66.5 166.5 66.5Z",
    fill: "#F2A581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 43C160 49.0751 153.575 53 147.5 53C141.425 53 122.5 59.0751 122.5 53C121.5 47 132.5 43.5 139.5 41C142.5 38 141 34.75 144 33.5C150 31 159.5 34.5 160 43Z",
    fill: "#FFD66D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.5 50C128.501 52.3316 128.5 57.5758 128.5 58C125.601 58 122 54.751 122 51.9394C122 49.1278 127 45.5 134 43C134 43 131 46.5 129.5 50Z",
    fill: "#FF6C44"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 39,
    r: 3,
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.5,
    cy: 37.5,
    r: 1.5,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 228.24,
    cy: 76.5695,
    rx: 20,
    ry: 4.68748,
    transform: "rotate(-40.5759 228.24 76.5695)",
    fill: "#F2A581"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 231.524,
    cy: 76.8911,
    rx: 20,
    ry: 4.68748,
    transform: "rotate(-15.5931 231.524 76.8911)",
    fill: "#F2A581"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 228.542,
    cy: 80.1566,
    rx: 20,
    ry: 4.68748,
    transform: "rotate(13.2809 228.542 80.1566)",
    fill: "#F2A581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.687 94.1393C162.721 92.5095 161.96 85.7828 174.639 71.9138C178.164 72.0771 186.221 73.6884 190.252 78.8276C195.292 85.2516 206.463 86.8785 210.541 95.9059C214.618 104.933 196.329 103.692 190.197 108.489C185.292 112.327 171.146 100.522 164.687 94.1393Z",
    fill: "#FFD66D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186 118C184.389 123.571 175.947 133.761 172.764 132.84C169.581 131.92 167.889 120.571 169.5 115C171.111 109.429 175.415 111.746 178.599 112.667C181.782 113.588 187.611 112.429 186 118Z",
    fill: "#F2A581"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.564,
    cy: 165.332,
    rx: 4.36136,
    ry: 1.5,
    transform: "rotate(-13.8079 187.564 165.332)",
    fill: "#FF6C44"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 189.393,
    cy: 166.809,
    rx: 4.36136,
    ry: 1.5,
    transform: "rotate(-36.7066 189.393 166.809)",
    fill: "#FF6C44"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 192.943,
    cy: 167.493,
    rx: 4.36136,
    ry: 1.5,
    transform: "rotate(-95.9328 192.943 167.493)",
    fill: "#FF6C44"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.532,
    cy: 165.112,
    rx: 4.36136,
    ry: 1.5,
    transform: "rotate(-171.723 195.532 165.112)",
    fill: "#FF6C44"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 168.593,
    cy: 162.498,
    rx: 4.36136,
    ry: 1.5,
    transform: "rotate(-13.8079 168.593 162.498)",
    fill: "#FF6C44"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 170.423,
    cy: 163.975,
    rx: 4.36136,
    ry: 1.5,
    transform: "rotate(-36.7066 170.423 163.975)",
    fill: "#FF6C44"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.972,
    cy: 164.659,
    rx: 4.36136,
    ry: 1.5,
    transform: "rotate(-95.9328 173.972 164.659)",
    fill: "#FF6C44"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.561,
    cy: 162.278,
    rx: 4.36136,
    ry: 1.5,
    transform: "rotate(-171.723 176.561 162.278)",
    fill: "#FF6C44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 199,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDodo);
export default __webpack_public_path__ + "static/media/dodo.8adad6490cbf95a4b8c295b649d94076.svg";
export { ForwardRef as ReactComponent };